import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectItem } from 'primeng/api'
import { Variable } from '../../../_models/variable-sarlaft';
import { CodigosTiposProcesosCreditos, TipoOpcion } from '../../../_enums/enum';
import { SarlaftSimuladorService } from '../../../_services/sarlaft-simulador.service';
import { NavService } from '../../../_services/_nav.service';
import { SarlaftCondicionesService } from '../../../_services/sarlaft-condiciones.service';
import { SarlaftService } from '../../../_services/sarlaft.service';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, from, of } from 'rxjs';
import { obteneItemTablaSarlaft } from '../../../utils/utilidades';

@Component({
  selector: 'app-sarlaft-modal-simulador',
  templateUrl: './sarlaft-modal-simulador.component.html',
  styleUrls: ['./sarlaft-modal-simulador.component.css']
})
export class SarlaftModalSimuladorComponent implements OnInit {

  cargando: boolean = false;
  guardando: boolean = false;
  listCondiciones: any[] = [];
  variables: Variable[] = [];
  lisgenerica: SelectItem[] = [];
  variablesSimulador: Variable[] = [];
  listValores: { [key: string]: string } = {};
  resultadoTotal: number = 0;
  score: any;
  codigosTiposProcesosCreditos: CodigosTiposProcesosCreditos = CodigosTiposProcesosCreditos.CREDITODIGITAL;
  mostrarResultado: boolean = false;
  public mostrarDeterminantes: boolean = false;
  public mostrarCuantitativas: boolean = false;

  constructor( private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private sarlaftSimuladorService: SarlaftSimuladorService,
              private navServicio: NavService,
              private sarlaftCondicionesService: SarlaftCondicionesService,
              private sarlaftServicio: SarlaftService ) { }

  async ngOnInit() {
    this.cargando = true;
    await this.cargaInicial();

  }

  async cargaInicial() {
    this.variables = await this.sarlaftServicio.listadorVariablesRegistradas().toPromise();
    const observables = [];
    for (const elemento of this.variables) {
      const opcion = this.buscarValorEnEnum(elemento.codigoVariableSarlaft);
      const observable = from(
        this.sarlaftCondicionesService.ejecutarServicios(opcion, elemento).toPromise()
      ).pipe(
        catchError((error) => {
          console.error('Error en servicio:', error);
          return of([]);
        }),
        map((response) => (response && response.length > 0 ? obteneItemTablaSarlaft(opcion, response[0]) : []))
      );
      observables.push(observable);
    }

    forkJoin(observables).subscribe(
      (respuestas) => {
        for (let i = 0; i < this.variables.length; i++) {
          const opcion = this.buscarValorEnEnum(this.variables[i].codigoVariableSarlaft);
          this.listCondiciones[opcion] = respuestas[i];
        }
        this.variablesSimulador = this.variables.filter(x => x.indicadorHabilitado);
        this.variablesSimulador = this.variablesSimulador.map(item => {
          let listasGenericas: any[] = [];
          if (this.listCondiciones[item.codigoVariableSarlaft] && this.listCondiciones[item.codigoVariableSarlaft].length > 0){
            listasGenericas = this.obtenerItem(item.codigoVariableSarlaft, this.listCondiciones[item.codigoVariableSarlaft]);
          }
          item.listGenerica = listasGenericas ? listasGenericas : [];
          return item;
        });
        this.mostrarDeterminantes = this.variablesSimulador.some(item => item.indicadorDeterminante);
        this.mostrarCuantitativas = this.variablesSimulador.some(item => !item.indicadorDeterminante);
        this.cargando = false;
      },
      (error) => {
        console.error('Error en forkJoin:', error);
      }
    );
  }

  buscarValorEnEnum(valor: string): TipoOpcion | undefined {
    const enumKeys = Object.keys(TipoOpcion);
    for (const key of enumKeys) {
      if (TipoOpcion[key] === valor) {
        return TipoOpcion[key] as TipoOpcion;
      }
    }
    return undefined;
  }
  cerrarSimulador() {
    this.ref.close();
  }
 obtenerItem(codigo: string, lisItems: any) {
    let lista = [];
    switch (codigo) {
      case TipoOpcion.VCANAL:
        lisItems.forEach(x => {
          lista.push({label: x.canal, value: x.idCanal});
        });
        return lista;
      case TipoOpcion.NACION:
      case TipoOpcion.JURISD:
        lisItems.forEach(x => {
          lista.push({label: x.descripcionDivisionPolitica, value: x.idDivisionPolitica});
        });
        return lista;
      case TipoOpcion.ACTECO:
        lisItems.forEach(x => {
          if(x.actividadEconomica && x.idActividadEconomica){
            lista.push({label: x.actividadEconomica, value: x.idActividadEconomica});
          }
        });
        return lista;
      case TipoOpcion.PEP:
        lisItems.forEach(x => {
          lista.push({label: x.pep, value: x.idListaPep});
        });
        return lista;
      case TipoOpcion.TIPOCU:
        lisItems.forEach(x => {
          lista.push({label: x.tipoOcupacion, value: x.idTipoOcupacion});
        });
        return lista;
      case TipoOpcion.PRODUC:
        lisItems.forEach(x => {
          lista.push({label: x.producto, value: x.idProducto});
        });
        return lista;
      case TipoOpcion.OCUPAC:
        lisItems.forEach(x => {
          lista.push({label: x.ocupacion, value: x.idOcupacion});
        });
        return lista;
      case TipoOpcion.INFIAC:
      case TipoOpcion.INFIEG:
      case TipoOpcion.INFIPA:
      case TipoOpcion.INFIPT:
      case TipoOpcion.INFIIN:
        if (Array.isArray(lisItems)) {
          lisItems.forEach(x => {
            const rangoInicialFormatted = `$${x.rangoInicial.toLocaleString()}`;
            const rangoFinalFormatted = `$${x.rangoFinal.toLocaleString()}`;
            lista.push({
              label: `${rangoInicialFormatted} - ${rangoFinalFormatted}`,
              value: x.idRiesgoSarlaftVariableCondicionInformacionFinanciera
            });
          });
        } else {
          lista.push({});
        }
        return lista;
      default:
        return;
    }
  }
  onDropdownChange(item: any) {
    const selectedValue = this.listValores['variable_'+ item.codigoVariableSarlaft];
    const selectedOption = item.codigoVariableSarlaft;

    if (this.listCondiciones[selectedOption]) {
      const selectedConditions = this.listCondiciones[selectedOption];
      let selectedCondition = null;
      for (const condition of selectedConditions) {
        for (const key in condition) {
          if (condition.hasOwnProperty(key) && condition[key] === selectedValue) {
            selectedCondition = condition;
            break;
          }
        }
        if (selectedCondition) {
          break;
        }
      }
      if (selectedCondition) {
        this.listValores['peso_'+ item.codigoVariableSarlaft] = selectedCondition.peso + '%';
        this.listValores['puntaje_'+ item.codigoVariableSarlaft] = selectedCondition.puntaje;
        this.listValores['resultado_'+ item.codigoVariableSarlaft] = selectedCondition.ponderacion;
      } else {
        this.listValores['peso_'+ item.codigoVariableSarlaft] = '0%';
        this.listValores['puntaje_'+ item.codigoVariableSarlaft] = '0';
        this.listValores['resultado_'+ item.codigoVariableSarlaft] = '0';
      }
    } else {
      this.listValores['peso_'+ item.codigoVariableSarlaft] = '0%';
      this.listValores['puntaje_'+ item.codigoVariableSarlaft] = '0';
      this.listValores['resultado_'+ item.codigoVariableSarlaft] = '0';
    }
    this.calcularSumaPorcentajePesoCuantitativas();
  }
  async calcularResultadoTotal() {
    this.guardando = true;
    const noSeHanSeleccionadoOpciones = this.variablesSimulador.every(item => {
      return !this.listValores['variable_' + item.codigoVariableSarlaft];
    });
    if (noSeHanSeleccionadoOpciones) {
      this.navServicio.setMesage(4, {
        severity: "success",
        summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
        detail: this.navServicio.buscarMensaje("SARLAFT.MSG_SELECCIONAR"),
      });
      this.guardando = false;
    }else{
      this.resultadoTotal = 0;
      for (const item of this.variablesSimulador) {
        const valorVariable = parseFloat(this.listValores['resultado_' + item.codigoVariableSarlaft]) || 0;
        this.resultadoTotal += valorVariable;
      }

      this.resultadoTotal = Math.ceil(this.resultadoTotal);
      this.score = await this.sarlaftSimuladorService.obtenerScoreSarlaft(this.resultadoTotal).toPromise();
      if (this.score && this.score.length > 0) {
        this.mostrarResultado = true;
        this.guardando = false;
      } else{
        this.navServicio.setMesage(4, {
          severity: "success",
          summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
          detail: this.navServicio.buscarMensaje("SARLAFT.MSG_SCOREFUERADERANGO"),
        });
        this.guardando = false;
      }
    }
  }
  calcularSumaPorcentajePesoCuantitativas() {
  let suma = 0;
  for (const item of this.variablesSimulador) {
    if (!item.indicadorDeterminante) {
      const peso = parseFloat(this.listValores['peso_' + item.codigoVariableSarlaft]);
      suma += isNaN(peso) ? 0 : peso;
    }
  }
  this.listValores['totalPesoCuantitativas'] = suma + '%';
  }
}
